// extracted by mini-css-extract-plugin
module.exports = {"root":"Label_root__1zg3T","optional":"Label_optional__2g_Ln","main":"Label_main__3BSHj","disabled":"Label_disabled__2xY7U"};